import React from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useIsStaff } from "@/hooks/useStaffRoles";

export const useFeatureFlags = () => {
  return useQuery({
    queryKey: ["feature-flags"],
    staleTime: 60 * 1000,
    queryFn: async () => {
      const { data } = await (supabase as any)
        .from("app_feature_flags_public")
        .select("key, enabled_for_staff, enabled_for_all");
      return data || [];
    },
  });
};

export const useFeatureFlagState = (key: string) => {
  const { data: flags, isLoading: flagsLoading } = useFeatureFlags();
  const { isStaff, isLoading: staffLoading } = useIsStaff();
  const flag = flags?.find((f: any) => f.key === key);
  const enabled = !!flag && (flag.enabled_for_all || (flag.enabled_for_staff && isStaff));

  return {
    enabled,
    isLoading: flagsLoading || staffLoading,
  };
};

export const useFeatureFlag = (key: string): boolean => {
  return useFeatureFlagState(key).enabled;
};

export const FeatureGate = ({
  flag,
  children,
}: {
  flag: string;
  children: React.ReactNode;
}) => {
  const enabled = useFeatureFlag(flag);
  return enabled ? <>{children}</> : null;
};
